import React from "react";
import { Alert } from "reactstrap";
import { Link } from "react-router-dom";

const SubscriptionsBrandingEnableAlert = ({ color = "warning" }) => (
  <Alert color={color}>
    Subscriptions are not enabled for your users yet. Enable them in{" "}
    <Link to="/branding">Brand Configuration</Link> before managing subscription settings.
  </Alert>
);

export default SubscriptionsBrandingEnableAlert;
